import { GetServerSidePropsContext } from 'next'
import { useRouter } from 'next/router'

import CardLists from '@/components/CardLists/CardLists'
import DefaultHead from '@/components/DefaultHead/DefaultHead'
import Main from '@/components/Main/Main'
import SimpleHeader from '@/components/SimpleHeader/SimpleHeader'
import SubMenu from '@/components/SubMenu/SubMenu'
import Tabs from '@/components/Tabs/Tabs'
import { GenericPageProps } from '@/types/page'
import { serverSidePropsFor } from '@/utils/helpers.server'

const SUBMENU_ITEMS = [
  { name: 'By Cycle', url: '' },
  { name: 'By Name', url: '/name' },
  { name: 'By Popularity', url: '/popularity' },
]

const TAB_SLUGS = [undefined, 'alpha', 'cycles']

const LandsSubPage = ({ data }: GenericPageProps) => {
  const router = useRouter()
  const color = router.query.color as string
  const slug = router.query.slug
  return (
    <Main>
      <DefaultHead data={data} />
      <SimpleHeader>{data.header}</SimpleHeader>
      <Tabs>
        <SubMenu
          items={SUBMENU_ITEMS.map((item) => ({
            ...item,
            url: TAB_SLUGS.includes(color) ? `/lands${item.url}` : `/lands/${color}${item.url}`,
          }))}
        />
      </Tabs>
      <CardLists
        disabledSortMethods={['synergy']}
        groupCardLists={!slug}
        initCardLists={data.container.json_dict.cardlists}
        topLeftEdge={!slug}
      />
    </Main>
  )
}

export const getServerSideProps = async (context: GetServerSidePropsContext) =>
  serverSidePropsFor(`${process.env.NEXT_PUBLIC_EDHREC_JSON_URL}/pages/lands/${context.query.color}.json`)

export default LandsSubPage
